/* unplugin-vue-components disabled */import { ElDatePicker as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/date-picker/style/css';
import { ElForm as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElButton as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-60d3c1a8"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索");
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索");
const _hoisted_3 = /*#__PURE__*/_createTextVNode("查看订单");
const _hoisted_4 = /*#__PURE__*/_createTextVNode("查看订单");
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import OrderList from './orderList.vue';
import { apiGSIncomePlayerList } from '@/api/gsManage';
import SelectCurrency from '../modules/selectCurrency.vue';
export default /*#__PURE__*/_defineComponent({
  props: {
    userId: null,
    gameId: null
  },
  setup(__props) {
    const props = __props;
    const currentCurrency = ref('USD');
    const activeCard = ref('playerList');
    const orderListParams = ref();
    const panes = [{
      title: '我的玩家',
      key: 'playerList'
    }, {
      title: '订单',
      key: 'orderList'
    }];
    const filter = ref({
      role_id: '',
      role_nickname: ''
    });
    const filterOrder = ref({
      role_id: '',
      date: ''
    });
    const columns = [{
      label: '角色ID',
      prop: 'role_id',
      width: 100
    }, {
      label: '角色昵称',
      prop: 'role_nickname'
    }, {
      label: '绑定GS时间',
      prop: 'created_at',
      slot: 'created_at'
    }, {
      label: '最近登录时间',
      prop: 'login_at',
      slot: 'login_at'
    }, {
      label: '充值总额',
      prop: 'charge_amount',
      header: 'charge_amount_header',
      align: 'right'
    }, {
      label: '操作',
      action: true
    }];
    const getTableData = async () => {
      tableLoading.value = true;
      const res = await apiGSIncomePlayerList({
        UserId: props.userId,
        current_page: current.value,
        page_size: pageSize.value,
        game_id: props.gameId,
        currency: currentCurrency.value,
        ...filter.value
      });
      tableLoading.value = false;
      if (res.code === 0) {
        tableData.value = res.data;
        total.value = res.meta.pagination.total;
      }
    };
    const handleClick = (type, data) => {
      if (type === 'allOrder') {
        activeCard.value = 'orderList';
        orderListParams.value = {};
        return;
      }
      if (type === 'orderInfo') {
        activeCard.value = 'orderList';
        orderListParams.value = data;
      }
    };
    const orderListRef = ref();
    const handleSearch = () => {
      var _orderListRef$value;
      (_orderListRef$value = orderListRef.value) === null || _orderListRef$value === void 0 ? void 0 : _orderListRef$value.getTableData();
    };
    const handleChangeCurrency = () => {
      getTableData();
    };
    const {
      tableData,
      tableLoading,
      current,
      pageSize,
      total,
      handleCurrentChange,
      handleSizeChange
    } = UseTable(getTableData);
    watch(() => props.gameId, val => {
      if (val) getTableData();
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_input = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_button = __unplugin_components_2;
      const _component_el_form = __unplugin_components_3;
      const _component_el_date_picker = __unplugin_components_4;
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      const _component_u_card = _resolveComponent("u-card");
      return _openBlock(), _createBlock(_component_u_card, {
        modelValue: activeCard.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => activeCard.value = $event),
        panes: panes
      }, {
        "left-extra": _withCtx(() => [activeCard.value === 'playerList' ? (_openBlock(), _createBlock(_component_el_form, {
          key: 0,
          inline: "",
          class: "search-container"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "角色ID"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: filter.value.role_id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filter.value.role_id = $event),
              clearable: "",
              placeholder: "输入角色ID"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "角色昵称"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: filter.value.role_nickname,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => filter.value.role_nickname = $event),
              clearable: "",
              placeholder: "输入角色昵称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: getTableData
            }, {
              default: _withCtx(() => [_hoisted_1]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true), activeCard.value === 'orderList' ? (_openBlock(), _createBlock(_component_el_form, {
          key: 1,
          inline: "",
          class: "search-container"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "角色ID"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: filterOrder.value.role_id,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => filterOrder.value.role_id = $event),
              clearable: "",
              placeholder: "输入角色ID"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "日期"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: filterOrder.value.date,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => filterOrder.value.date = $event),
              style: {
                "width": "280px"
              },
              type: "daterange",
              "range-separator": "-",
              "start-placeholder": "开始时间",
              "end-placeholder": "结束时间"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: handleSearch
            }, {
              default: _withCtx(() => [_hoisted_2]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true)]),
        extra: _withCtx(() => [activeCard.value === 'playerList' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          class: "marginR10",
          link: "",
          type: "primary",
          onClick: _cache[4] || (_cache[4] = $event => handleClick('allOrder'))
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(SelectCurrency, {
          modelValue: currentCurrency.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => currentCurrency.value = $event),
          onOnChange: handleChangeCurrency
        }, null, 8, ["modelValue"])]),
        default: _withCtx(() => [_createVNode(_component_u_card_pane, {
          name: "playerList"
        }, {
          default: _withCtx(() => [_createVNode(UTable, {
            options: columns,
            "row-key": "rid",
            data: _unref(tableData),
            loading: _unref(tableLoading),
            total: _unref(total),
            "current-page": _unref(current),
            "page-size": _unref(pageSize),
            onSizeChange: _unref(handleSizeChange),
            onCurrentChange: _unref(handleCurrentChange),
            pagination: ""
          }, {
            charge_amount_header: _withCtx(() => [_createElementVNode("span", null, "充值总额 (" + _toDisplayString(currentCurrency.value) + ")", 1)]),
            created_at: _withCtx(({
              scope
            }) => [_createTextVNode(_toDisplayString(_ctx.$filters.formatDate(scope.row.created_at)), 1)]),
            login_at: _withCtx(({
              scope
            }) => [_createTextVNode(_toDisplayString(_ctx.$filters.formatDate(scope.row.login_at)), 1)]),
            action: _withCtx(({
              scope
            }) => [_createVNode(_component_el_button, {
              link: "",
              type: "primary",
              onClick: $event => handleClick('orderInfo', scope.row)
            }, {
              default: _withCtx(() => [_hoisted_4]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          }, 8, ["data", "loading", "total", "current-page", "page-size", "onSizeChange", "onCurrentChange"])]),
          _: 1
        }), _createVNode(_component_u_card_pane, {
          name: "orderList"
        }, {
          default: _withCtx(() => [_createVNode(OrderList, {
            ref_key: "orderListRef",
            ref: orderListRef,
            gameId: __props.gameId,
            params: orderListParams.value,
            currency: currentCurrency.value,
            filterOrder: filterOrder.value
          }, null, 8, ["gameId", "params", "currency", "filterOrder"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});